import React, { useEffect } from 'react'
import { useDispatch, connect } from 'react-redux'
import { getBreadcrumbs } from '../../../../redux/actions/breadcrumbs'
import { BreadcrumbComponent } from './mixins'

const Breadcrumbs = ({ links, filtersApplied }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getBreadcrumbs(filtersApplied))
  }, [filtersApplied])

  return <BreadcrumbComponent links={links} />
}

const states = ({ filtersStore, breadcrumbsStore }) => ({
  links: breadcrumbsStore.breadcrumbs?.links,
  filtersApplied: filtersStore.filtersApplied,
})

export default connect(states)(Breadcrumbs)
